interface SvgUpRightProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgUpRight(props: SvgUpRightProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M7.5 4.5V6H16.9425L4.5 18.4425L5.5575 19.5L18 7.0575V16.5H19.5V4.5H7.5Z" fill="currentColor" /></svg>;
}